export default "__VITE_ASSET__CP_EPsat__"